var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('circle',{class:['player-token', 'planet-fill', _vm.planetClass],attrs:{"cx":"0","cy":"0","r":"20"}})])}
var staticRenderFns = []

export { render, staticRenderFns }